import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

import DropZone from 'components/Shared/DropZone';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';
import { MotifResolutionCodes } from 'constants.js';
import { CausePrincipaleCodes } from 'constants.js';

import stringHelper from 'utils/stringHelper';

const styles = theme => ({
    formControl: {
        width: '100%'
    },

    detailValue: {
        paddingLeft: theme.spacing(4)
    }
});


/* Liste des réponses possibles */
const decisionFournisseurLabel = "Décision de fournisseur";
const decisionsFournisseur = [
    'Accepté',
    'Refusé',
];


const traitementLabel = "Qui doit effectuer le traitement informatique ?";
const traitements = [
    'L\'administrative de région',
    'L\'émetteur du dossier après-vente',
];

const informationLabel = "Le client a-t-il été informé ?";
const informations = [
    'Oui (le dossier après-vente sera clôturé à l\'enregistrement)',
    'Non (d\'autres actions suivent sur ce dossier après-vente)',
];


const fraisAnnexeLabel = "Frais annexes";
const transportLabel = "Transport";
const commandeLabel = "Commande chez le fournisseur";

class RetourFournisseurDialogContent extends React.Component {

    state = {
        decisionFournisseur: '',
        traitement: '',
        information: '',

        fraisAnnexe: '',
        transport: '',
        commande: '',

        fichiersIds: [],

        commentaire: ''
    };

    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (stringHelper.isNullOrWhitespace(newState.decisionFournisseur)) {
            return null;
        }
        else {
            if (newState.decisionFournisseur === '0') {
                if (stringHelper.isNullOrWhitespace(newState.traitement)) {
                    return null;
                }
            }
            if (newState.decisionFournisseur === '1') {
                if (stringHelper.isNullOrWhitespace(newState.information)) {
                    return null;
                }
            }
        }
        



        let actionData = {
            code: action.code,
            details: [
            {
                code: ReclamationActionDetailCodes.DecisionFournisseur,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: decisionFournisseurLabel,
                position: 0,
                valeurString: decisionsFournisseur[newState.decisionFournisseur],
                valeurInteger: newState.decisionFournisseur
            }]
        };


        if (newState.decisionFournisseur === '0') {
            actionData.details.push({
                code: ReclamationActionDetailCodes.TraitementInformatique,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: traitementLabel,
                position: 1,
                valeurString: traitements[newState.traitement],
                valeurInteger: newState.traitement
            });


            actionData.details.push({
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: fraisAnnexeLabel,
                position: actionData.details.length,
                valeurString: newState.fraisAnnexe
            });

            actionData.details.push({
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: transportLabel,
                position: actionData.details.length,
                valeurString: newState.transport
            });

            actionData.details.push({
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: commandeLabel,
                position: actionData.details.length,
                valeurString: newState.commande
            });
        }

        if (newState.decisionFournisseur === '1') {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: informationLabel,
                position: 1,
                valeurString: informations[newState.information],
                valeurInteger: newState.information
            });
        }


        if (newState.commentaire) {

            let detail = {
                code: "COMMENTAIRE",
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: newState.commentaire
            };

            actionData.details.push(detail);
        }

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }

    handleChange = (event) => {

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        let clotureData = null;
        // Si refus, cloture automatique
        if (newState.decisionFournisseur === "1" && newState.information === "0") {
            clotureData = {
                motifResolutionCode: MotifResolutionCodes.ConditionsNonRempliesPourDeclencherLeRetour,
                causePrincipaleCode: CausePrincipaleCodes.RefusFournisseur,
                causePrincipaleDetailId: 0,
                utilisateurFautifId: 0,
                commentaire: '',
                mailAutomatique: ''
            };
        }

        this.props.onChange(actionData, clotureData);
    }

    render() {
        const { classes } = this.props;
        const { decisionFournisseur, traitement, information, commentaire, fraisAnnexe, transport, commande } = this.state;

        return (
            <DialogContent>


                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">{decisionFournisseurLabel}</FormLabel>
                    <RadioGroup
                        name="decisionFournisseur"
                        value={decisionFournisseur}
                        onChange={e => this.handleChange(e)}
                    >
                        {decisionsFournisseur.map((decision, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={decision} />
                        ))}

                    </RadioGroup>
                </FormControl>

                {decisionFournisseur === '0' &&

                    <React.Fragment>

                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormLabel component="legend">{traitementLabel}</FormLabel>
                            <RadioGroup
                                name="traitement"
                                value={traitement}
                                onChange={e => this.handleChange(e)}
                            >
                                {traitements.map((treatment, index) => (
                                    <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={treatment} />
                                ))}

                            </RadioGroup>
                        </FormControl>


                        <TextField className={classes.formControl}
                            id="fraisAnnexe"
                            name="fraisAnnexe"
                            label={fraisAnnexeLabel}
                            placeholder={fraisAnnexeLabel}
                            margin="normal"
                            value={fraisAnnexe}
                            onChange={this.handleChange}
                        />



                        <TextField className={classes.formControl}
                            id="transport"
                            name="transport"
                            label={transportLabel}
                            placeholder={transportLabel}
                            margin="normal"
                            value={transport}
                            onChange={this.handleChange}
                        />



                        <TextField className={classes.formControl}
                            id="commande"
                            name="commande"
                            label={commandeLabel}
                            placeholder={commandeLabel}
                            margin="normal"
                            value={commande}
                            onChange={this.handleChange}
                        />
                    </React.Fragment>

                }
    
    
                {decisionFournisseur === '1' &&

                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel component="legend">{informationLabel}</FormLabel>
                        <RadioGroup
                            name="information"
                            value={information}
                            onChange={e => this.handleChange(e)}
                        >
                            {informations.map((info, index) => (
                                <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={info} />
                            ))}

                        </RadioGroup>
                    </FormControl>

                }
                

                <TextField className={classes.formControl}
                    id="commentaire"
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={this.handleChange}
                />

                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
            </DialogContent>
        );
    }
}

RetourFournisseurDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(RetourFournisseurDialogContent);